import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M15.5 7.33342H0.5M11.3333 0.666748V4.00008M4.66667 0.666748V4.00008M4.5 17.3334H11.5C12.9001 17.3334 13.6002 17.3334 14.135 17.0609C14.6054 16.8212 14.9878 16.4388 15.2275 15.9684C15.5 15.4336 15.5 14.7335 15.5 13.3334V6.33342C15.5 4.93328 15.5 4.23322 15.2275 3.69844C14.9878 3.22803 14.6054 2.84558 14.135 2.6059C13.6002 2.33341 12.9001 2.33341 11.5 2.33341H4.5C3.09987 2.33341 2.3998 2.33341 1.86502 2.6059C1.39462 2.84558 1.01217 3.22803 0.772484 3.69844C0.5 4.23322 0.5 4.93328 0.5 6.33341V13.3334C0.5 14.7335 0.5 15.4336 0.772484 15.9684C1.01217 16.4388 1.39462 16.8212 1.86502 17.0609C2.3998 17.3334 3.09987 17.3334 4.5 17.3334Z",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }